/* 🤖 this file was generated by svg-to-ts */
export const emperorIconBox2: {
  name: 'box_2';
  data: string;
} = {
  name: 'box_2',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M21.996 8.98c-.01-.12-.03-.23-.07-.34 -.02-.03-.03-.06-.04-.08 -.02-.04-.04-.08-.06-.12l-4-6c-.19-.28-.5-.45-.84-.45h-10c-.34 0-.65.16-.84.44l-4 6c-.03.03-.04.07-.06.11 -.02.02-.03.05-.04.08 -.05.1-.07.22-.07.33 0 0-.01.01-.01.01v12c0 .55.44 1 1 1h18c.55 0 1-.45 1-1v-12c0-.01-.01-.02-.01-.02Zm-2.87-.99h-6.14v-4h3.465l2.66 4Zm-11.6-4h3.465v4H4.86l2.66-4Zm12.465 16h-16v-10h16v10Z"/></svg>`
};
